import { useDispatch, useSelector } from "react-redux";
import cancel_img from '../../assets/images/cancel.svg'

import { selectTranslations } from "../../services/i18n/i18nSlice";
import { selectAppPersonalizations } from "../../services/utils/appInfoSlice";
import { confirmAccountEmail, confirmAccountEmailWithToken, selectAppAuth, verifyAccountEmail } from "../../services/auth/authSlice";
import { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';


import Text from "../../components/Text";
import TitleH1 from "../../components/TitleH1";
import Button from "../../components/Button";
import PinInput from 'react-pin-input';
import { checkUserFields, selectUserFields, selectUserInfo } from "../../features/User/userSlice";
import Anchor from "../../components/Anchor";
import { BASE_URL } from "../../config/constants";

import error_img from '../../assets/images/error.svg'
import Spinner from 'react-bootstrap/Spinner';


import './LoginScreen.css'
import AdminWaitingScreen from "./AdminWaitingScreen";



export default function ConfirmToken () {

    const personalizations = useSelector(selectAppPersonalizations)
    const userAuth = useSelector(selectAppAuth)
    const userInfo = useSelector(selectUserInfo)
    const t = useSelector(selectTranslations);
    const missingFields = useSelector(checkUserFields)
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const location = useLocation()



    useEffect(()=>{
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString)
        const login_token = urlParams.get('security_token')
        if(!login_token)
            navigate('/', {replace: true})
        else {
           dispatch(confirmAccountEmailWithToken({login_token: login_token})) 
        }
    },[])
    

    return(
        <div id="loginScreen">
            { !userAuth?.auth_token? 
            <>
                { userAuth.authPending? 
                    <div className="fh-div d-flex flex-column align-items-center justify-content-between">
                        <div className="top">
                            <img src={personalizations?.logo_url} className="mx-auto d-block" />
                            <TitleH1 className="text-center mt-2">{t.login.waiting_token_login}</TitleH1>
                            <Text className="text-center mt-2">{t.login.waiting_token_login_text}</Text>
                            <div className="d-flex justify-content-center">
                                <Spinner />
                            </div>
                        </div>
                    </div> :
                    <div className="fh-div d-flex flex-column align-items-center justify-content-between">
                        <div className="top">
                            <img src={error_img} className="mx-auto d-block" style={{maxWidth:'150px'}}/>
                            <TitleH1 className="text-center mt-2">{t.login.error_token_login}</TitleH1>
                            <Text className="text-center mt-2">{t.login.error_token_login_text}</Text>
                            <Link to={'/'}>
                                <Button type={'primary'} className="mt-3 mx-auto">{t.buttons.back_home}</Button>
                            </Link>
                        </div>
                    </div>
                }
            </> : 
            <>
                {   
                    userInfo.user_data && userAuth ?
                    <>
                        { userAuth?.admin_check_required || userInfo?.user_data?.state === "waiting_admin_check" ? 
                            <Navigate to={'/login/waiting_approval'} replace />
                        :
                            <>
                                { missingFields || !userInfo.user_data?.legal_checks?.external_legal_check ?
                                    <Navigate to={'/login/onboarding'} replace />
                                :
                                    <Navigate to={userAuth?.origin_location} replace />
                                }
                            </>
                        }
                    </> : ""
                }
            </>
            }
        </div>
    )
}